import { colors } from '../../colors';
var imageSlider = {
  primaryBgColor: colors.white,
  secondaryBgColor: colors.white,
  textColorDark: colors.onyx,
  textColorLight: colors.white
};
export default imageSlider;